import * as React from "react";
import { Navigator } from "../../../../../Shared/Wizards/Entities/Navigator";
import { FormComponent } from "../../../../../../react-core/Html/FormComponent";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Urls } from "../../../../../Dashboard/Urls";
import { Spinner } from "../../../../../../react-core/Html/Spinner";
import { IStepConfig, Process } from "../../../../../Shared/Process/Process/Process";
import { Contents } from "../../../../../Dashboard/Resoures/Contents";
import { CompanyWizardAction } from "../../Actions/CompanyWizardAction";
import { stepperName } from "../../Resource/Content";
import { CompanyStore } from "../../Stores/Variable";
import { CompanyDetail } from "../../../../../../Wrap/Models/Models/Company/CompanyDetail";
import { FirmDetail } from "./FirmDetails";
import { Commission } from "./Commission";

interface IViewCompanyProps extends React.Props<ViewCompany> {}

interface IViewCompanyState {
    data: CompanyDetail;
    errorMsg: string[];
}

export class ViewCompany extends FormComponent<IViewCompanyProps, IViewCompanyState> {
    constructor(props: any) {
        super(props);
        this.state = {
            data: null,
            errorMsg: [],
        };
        this.subscribeToStore(CompanyStore, () => this.onCompanyStoreChange());
    }

    componentDidMount() {
        const id = getQueryParameters()["id"];
        CompanyWizardAction.getViewCompany(id);
    }

    private onCompanyStoreChange() {
        this.setState({ data: CompanyStore.getSingleData() });
    }

    private onExit() {
        Navigator.navigateTo(Urls.get().main.CompanySetup);
    }

    render() {
        if (!this.state.data) {return <Spinner />;}

        const stepsConfig: IStepConfig[] = [
            {
                title: stepperName.stepOne,
                url: Urls.get().CompanyViewFirmDetail,
                path: Contents.URLMap.firmdetail,
                component: <FirmDetail data={this.state.data} />,
            },
            {
                title: stepperName.stepTwo,
                url: Urls.get().CompanyViewCommission,
                path: Contents.URLMap.remunerationAndValuation,
                component: <Commission data={this.state.data} />,
            },
        ];

        return (
            <Process
                stepsConfig={stepsConfig}
                onCancel={null}
                onSave={this.onExit}
                processTitle="View Company"
                goBacktoFirst={false}
                active={false}
                isShowError={false}
                errorMsg={[]}
            />
        );
    }
}
